import React from 'react';
import PropTypes from 'prop-types';
import {
    TableHeaderCell as TableHeaderCellComponent,
    TableHeaderCellSortable,
} from 'smartsuite-ui';
import tableCellRenderTypes from './tableCellRenderTypes';

/* eslint-disable complexity */
export default function TableHeader({
    columnConfig,
    columnIndex,
    legendFormatter,
    sortObject,
    setSort,
}) {
    const { colspan, dataKey, renderType, sortKey, label } = columnConfig;
    const scope = colspan > 1 ? 'colgroup' : 'col';

    if (renderType === tableCellRenderTypes.placeholder) {
        return <TableHeaderCellComponent colSpan={colspan} scope={scope} />;
    }

    if (renderType === tableCellRenderTypes.staticParentHeader) {
        return (
            <TableHeaderCellComponent colSpan={colspan} scope={scope}>
                {legendFormatter(label ?? dataKey, null, columnIndex)}
            </TableHeaderCellComponent>
        );
    }

    return (
        <TableHeaderCellSortable
            columnName={sortKey ?? dataKey}
            sortObject={sortObject}
            onSort={setSort}
        >
            {legendFormatter(label ?? dataKey, null, columnIndex)}
        </TableHeaderCellSortable>
    );
}
/* eslint-enable complexity */

TableHeader.propTypes = {
    columnConfig: PropTypes.instanceOf(Object).isRequired,
    columnIndex: PropTypes.number.isRequired,
    legendFormatter: PropTypes.func.isRequired,
    setSort: PropTypes.func.isRequired,
    sortObject: PropTypes.instanceOf(Object),
};

TableHeader.defaultProps = {
    sortObject: null,
};
